module.exports = __webpack_public_path__ + "static/media/dineOrder.92cc6fa4.svg";